<script setup lang="ts">
import type { defaultSideItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<defaultSideItemProps>(), {})

const app = useNuxtApp()
const storeIndex = useStoreIndex()
</script>

<template>
  <div class="c-specialSideItem">
    <nuxt-link
      class="c-specialSideItem_image"
      v-bind:to="`/special/${item.article_slug}`"
    >
      <CommonImage
        v-bind:src="storeIndex.getArticleEyeCatchImageURL(item.eye_catch_image_object, 's')"
        error-src="/images/noimage.svg"
        v-bind:alt="item.title"
        object-fit="cover"
        is-hover-effect
        width="110"
        height="83"
      />
    </nuxt-link>
    <nuxt-link
      class="c-specialSideItem_eventType c-clampLines is-clampline3"
      v-bind:to="`/special/${item.article_slug}`"
    >
      {{ item.title }}
    </nuxt-link>
  </div>
</template>

<style lang = "scss" scoped>
.c-specialSideItem {
  display: flex;
  align-items: flex-start;
  margin-top: 15px;
  margin-bottom: 14px;

  &_image {
    flex-shrink: 0;
    width: 110px;
  }

  &_eventType {
    flex-grow: 1;
    margin-left: 10px;
    color: var(--color_text_base);
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
  }
}
</style>
